import isFinalState from "./isFinalState";
const areAnyNonFinal = (items) => {
    var _a;
    return (_a = items === null || items === void 0 ? void 0 : items.some((el) => !isFinalState(el.status))) !== null && _a !== void 0 ? _a : false;
};
export default areAnyNonFinal;
